export default __webpack_public_path__ + "static/media/bgaming.322bb0a0.svg";